/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenancePricingCombinationResponseDto
 */
export interface PartnerMaintenancePricingCombinationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenancePricingCombinationResponseDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationResponseDto
     */
    takeChargeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationResponseDto
     */
    interventionMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationResponseDto
     */
    resolutionMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationResponseDto
     */
    priceAmount: number;
}

/**
 * Check if a given object implements the PartnerMaintenancePricingCombinationResponseDto interface.
 */
export function instanceOfPartnerMaintenancePricingCombinationResponseDto(value: object): value is PartnerMaintenancePricingCombinationResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('takeChargeMinutes' in value) || value['takeChargeMinutes'] === undefined) return false;
    if (!('interventionMinutes' in value) || value['interventionMinutes'] === undefined) return false;
    if (!('resolutionMinutes' in value) || value['resolutionMinutes'] === undefined) return false;
    if (!('priceAmount' in value) || value['priceAmount'] === undefined) return false;
    return true;
}

export function PartnerMaintenancePricingCombinationResponseDtoFromJSON(json: any): PartnerMaintenancePricingCombinationResponseDto {
    return PartnerMaintenancePricingCombinationResponseDtoFromJSONTyped(json, false);
}

export function PartnerMaintenancePricingCombinationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenancePricingCombinationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'takeChargeMinutes': json['takeChargeMinutes'],
        'interventionMinutes': json['interventionMinutes'],
        'resolutionMinutes': json['resolutionMinutes'],
        'priceAmount': json['priceAmount'],
    };
}

export function PartnerMaintenancePricingCombinationResponseDtoToJSON(json: any): PartnerMaintenancePricingCombinationResponseDto {
    return PartnerMaintenancePricingCombinationResponseDtoToJSONTyped(json, false);
}

export function PartnerMaintenancePricingCombinationResponseDtoToJSONTyped(value?: PartnerMaintenancePricingCombinationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'takeChargeMinutes': value['takeChargeMinutes'],
        'interventionMinutes': value['interventionMinutes'],
        'resolutionMinutes': value['resolutionMinutes'],
        'priceAmount': value['priceAmount'],
    };
}

